// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 550px) {
    .PhotoBy{
        position: fixed;
        bottom: 1vh;
        left: 1vw;
        color: rgba(255, 255, 255, .45);
        font-size: 15px;
    }
}

@media only screen and (max-width: 550px) {
    .PhotoBy{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Body/photoBy.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,+BAA+B;QAC/B,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media only screen and (min-width: 550px) {\r\n    .PhotoBy{\r\n        position: fixed;\r\n        bottom: 1vh;\r\n        left: 1vw;\r\n        color: rgba(255, 255, 255, .45);\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 550px) {\r\n    .PhotoBy{\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
